const LAUNDRY_OPTION_CONNECTIONS = 'washer/dryer - connections';
const LAUNDRY_OPTION_IN_UNIT = 'washer/dryer - in unit';
const LAUNDRY_OPTION_ON_SITE = 'washer/dryer - on-site';
const LAUNDRY_OPTION_NO_PREFERENCE = 'washer/dryer - no preference';

const laundryOptionItems = [
  {
    label: 'Connections are ok',
    value: LAUNDRY_OPTION_CONNECTIONS,
  },
  {
    label: 'Provided in-unit',
    value: LAUNDRY_OPTION_IN_UNIT,
  },
  {
    label: 'Anywhere on-site',
    value: LAUNDRY_OPTION_ON_SITE,
  },
  {
    label: 'No preference',
    value: LAUNDRY_OPTION_NO_PREFERENCE,
  },
];

export default laundryOptionItems;
